<template>
<div class="pager-container">
    <div class="input-container-pager" :class="{'invisible-input': useBarcode, 'androidMode': isAndroidMode()}">
        <h1>{{ getString('insira_numero_pager') }}</h1>

        <input v-if="useBarcode" id="pagerInput" type="text" v-on:keyup.13="!useBarcode ? confirmPagerCode() : ''" autocomplete="off"
            inputmode="numeric" data-layout="numeric" v-model="pagerNumber" @input="sanitizePagerNumber">
        <div v-else id="pagerInputDiv" class="div-input-android" ref="pagerInputDiv" @click="showKeyboard()"></div>
    </div>

    <img :src="getImage() || pager">

    <div class="footer-buttons-pager" :class="{'two-buttons-grid': !useBarcode}">
        <DefaultButton :outlined="!useBarcode" :text="getString('cancelar')" @defaultBtnClick="navigateBack()"></DefaultButton>
        <DefaultButton v-if="!useBarcode" :text="getString('confirmar')" @defaultBtnClick="validatePagerCode()"></DefaultButton>
    </div>

    <div class="keyboard-overlay" v-if="visible" @click="closeKeyboard()"></div>
    <AndroidKeyboard id="android-keyboard" v-if="visible"
        :inputElement="inputElement"
        :layout="layout"
        :bigNumeric="true"
        :maxCaracteres="6">
    </AndroidKeyboard>
</div>
</template>

<script>
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '@/assets/controllers/CartController'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'

export default {
    name: 'Pager',
    components: {
        CartController,
        Util,
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            visible: false,
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            pagerNumber: null,
            gertecBarcodeInterval: null,
            androidPagerCode: '',
            useBarcode: Util.getLocalConfigs('useBarcode'),
            pager: require('../../static/icons/pager.jpg'),
            idSolDigCons: Util.getLocalConfigs('idSolDigCons'),
            ignoreQrCodeSk: Util.getLocalConfigs('ignoreQrCode') || false
        }
    },
    mounted () {
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            setTimeout(() => {
                window.GertecBarcodeReader.startDecode(this.ignoreQrCodeSk)
            }, 1000)

            this.gertecBarcodeInterval = setInterval(() => {
                let readedCode = window.GertecBarcodeReader.getReadedCode()
                if (readedCode) {
                    this.androidPagerCode = readedCode
                    this.confirmPagerCode()
                }
            }, 1000)
        } else if (this.useAndroidBarCode()) {
            document.addEventListener('keypress', this.handleAndroidKeypress)
        } else if (this.useBarcode) {
            document.getElementById('pagerInput').addEventListener('keypress', this.handleKeypress)
            document.getElementById('pagerInput').focus()
        } else {
            this.showKeyboard()
        }
    },
    beforeDestroy () {
        if (Util.isAndroidMode() && Util.isGertecSk210()) {
            clearInterval(this.gertecBarcodeInterval)
            window.GertecBarcodeReader.stopDecode()
        } else if (this.useAndroidBarCode()) {
            document.removeEventListener('keypress', this.handleAndroidKeypress)
        }
    },
    methods: {
        sanitizePagerNumber: function () {
            this.pagerNumber = this.pagerNumber.replace(/[^0-9]+/g, '')
        },
        sanitizeAndroidPagerCode: function () {
            this.androidPagerCode = this.androidPagerCode.replace(/[^0-9]+/g, '')
        },
        useAndroidBarCode: function () {
            return Util.isAndroidMode() && Util.getLocalConfigs('usePager') && this.useBarcode
        },
        showKeyboard: function () {
            this.inputElement = this.$refs.pagerInputDiv
            this.visible = true
        },
        closeKeyboard: function () {
            this.visible = false
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        handleKeypress: function (event) {
            if (event.key === 'Enter' && this.useBarcode) {
                this.confirmPagerCode()
            }
        },
        handleAndroidKeypress: function (event) {
            if (event.key === 'Enter') {
                this.sanitizeAndroidPagerCode()
                this.confirmPagerCode()
            } else {
                this.androidPagerCode += event.key
            }
        },
        confirmPagerCode: function () {
            this.sanitizeAndroidPagerCode()
            let pagerCode = this.useAndroidBarCode() ? this.androidPagerCode : this.readPagerCodeInput()
            CartController.setPagerCode(pagerCode)
            // this.$router.push('consumer')
            if (this.idSolDigCons) {
                this.$router.push('consumer')
            } else {
                this.$router.push('payment')
            }
        },
        readPagerCodeInput: function () {
            if (this.useBarcode) return document.getElementById('pagerInput').value
            return this.$refs.pagerInputDiv.innerText
        },
        validatePagerCode: function () {
            let pagerCode = this.readPagerCodeInput()
            if (pagerCode && pagerCode !== '') {
                this.confirmPagerCode()
            } else {
                Util.showInfoModal(this.getString('por_favor_insira_comanda'))
            }
        },
        getImage: function () {
            return Util.getConfigImage('pager')
        },
        navigateBack: function () {
            this.$router.back()
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .pager-container {
        background-color: white;
        height: 100%;
    }

    .input-container-pager {
        z-index: 2;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        h1 {
            padding: 50px 0 25px 0;
            color: @primary-color;
            font-size: 50px;
        }

        .div-input-android {
            width: 200px;
            height: 50px;
            font-size: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: white;
            color: black;
            border: 2px solid black;
            border-radius: 5px;
            padding: 0 20px;
        }

        #pagerInput {
            width: 200px;
            height: 50px;
            font-size: 50px;
            text-align: center;
        }
        &.androidMode {
            padding: 20px 0 10px 0;
        }
    }

    .invisible-input {
        opacity: 0;
    }

    img {
        z-index: 1;
        position: absolute;
        top: 0;
        height: 100vh;
        max-width: 100vw;
        object-fit: contain;
        margin: auto;
        background-color: white;
    }

    .footer-buttons-pager {
        z-index: 2;
        display: grid;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: 0px;
        background: rgba(0, 0, 0, 0.1);
        padding: 20px;
    }

    .two-buttons-grid {
        grid-template-columns: auto auto;
    }

    #android-keyboard {
        .keyboard;
        bottom: 60px;
        margin: auto;
    }

    .keyboard-overlay {
        z-index: 2;
        position: absolute;
        width: 100vw;
        height: 100vh;
        // background: rgba(194, 9, 9, 0.8);
    }

    // span.key.accept.control.featured {
    //     display: none;
    // }

    @media (max-width: 698px) { // Gertec SK210
        .input-container-pager {
            h1 {
                padding: 0 0 10px 0;
                font-size: 30px;
            }
            .div-input-android {
                width: 100px;
                height: 35px;
                font-size: 25px;
                border: 1.5px solid black;
                padding: 0 10px;
            }
        }
        img {
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 70vh;
        }
        .footer-buttons-pager {
            padding: 5px 10px;
        }
        #android-keyboard {
            bottom: 30px;
            margin: 0;
            .small-screen-keyboard;
        }
    }

    @media (min-width: 799px) and (max-width: 1025px) {

        .input-container-pager {

            h1 {
                padding: 20px 0 10px 0;
                font-size: 35px;
            }

            #pagerInput {
                height: 35px;
                font-size: 35px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Pager.vue